// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Components
import { Dialog as MDialog } from "@material-ui/core";

const Dialog = MDialog;

export default Dialog;
